import { Route, Switch } from "react-router-dom";

import AcordoDetalhesPage from "./Detalhes";
import AcordoListagemPage from "./Listagem";

function AcordoPages() {
  return (
    <Switch>
      <Route exact path="/financeiro/receita/acordo" component={AcordoListagemPage} />
      <Route exact path="/financeiro/receita/acordo/:id" component={AcordoDetalhesPage} />
    </Switch>
  );
}

export default AcordoPages;
